<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: '/' }">{{currentClient}}</el-breadcrumb-item> -->
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/reports` }">Reports</el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <div v-if="!loading" class="top-margin">
      <el-row>
        <el-col>
          <el-tabs v-model="activeTab" @tab-click="reportParameters.reportPath = null">
            <el-tab-pane label="Coding" name="coding">
              <el-form v-if="!loading" ref="reportParametersForm" label-position="top" :model="reportParameters"
                :rules="reportParameters.rules" @submit.prevent.native>
                <el-form-item label="Report" prop="reportPath">
                  <el-select :default-first-option="true" v-model="reportParameters.reportPath"
                    placeholder="Select Report" filterable>
                    <el-option v-for="report in reports.filter(x => x.reportType === 1)" :key="report.reportPath"
                      :label="report.reportName" :value="report.reportPath">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Date Range" prop="dateRange">
                  <el-date-picker v-model="reportParameters.dateRange" type="daterange" range-separator="To"
                    start-placeholder="Start date" end-placeholder="End date" format="MM/dd/yyyy"
                    value-format="MM/dd/yyyy">
                  </el-date-picker>
                </el-form-item>
                <el-button style="margin-top: 20px;" type="primary" @click="generateReport">Generate Report</el-button>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="Review" name="review">
              <el-form v-if="!loading" ref="reportParametersForm" label-position="top" :model="reportParameters"
                :rules="reportParameters.rules" @submit.prevent.native>
                <el-form-item label="Report" prop="reportPath">
                  <el-select :default-first-option="true" v-model="reportParameters.reportPath"
                    placeholder="Select Report" filterable>
                    <el-option v-for="report in reports.filter(x => x.reportType === 2)" :key="report.reportPath"
                      :label="report.reportName" :value="report.reportPath">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Date Range" prop="dateRange">
                  <el-date-picker v-model="reportParameters.dateRange" type="daterange" range-separator="To"
                    start-placeholder="Start date" end-placeholder="End date" format="MM/dd/yyyy"
                    value-format="MM/dd/yyyy">
                  </el-date-picker>
                </el-form-item>
                <el-button style="margin-top: 20px;" type="primary" @click="generateReport">Generate Report</el-button>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <hia-loading v-if="generatingReport"></hia-loading>
          <el-table v-if="!generatingReport && files.length > 0" :data="files"
            style="margin-top: 20px; width: 400px; font-size:13px;">
            <el-table-column prop="fileName" label="" min-width="100">
            </el-table-column>
            <el-table-column prop="fileUrl" align="center" label="" min-width="40">
              <template slot-scope="scope">
                <a v-if="!isIE()" :href="scope.row.fileUrl" :download="scope.row.fileName"><i
                    class="mdi mdi-file-download-outline"></i>Download</a>
                <a v-if="isIE()" href="#" @click="downloadIe(scope.row)"><i
                    class="mdi mdi-file-download-outline"></i>Download</a>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'reports',
    mixins: [HiaAuthorization],
    data() {
      return {
        activeTab: 'coding',
        loading: true,
        generatingReport: false,
        reportParameters: {
          reportPath: '',
          dateRange: '',
          rules: {
            reportPath: [
              { required: true, message: 'Please Select Report', trigger: 'none' }
            ],
            dateRange: [
              { required: true, message: 'Please Set Date Range', trigger: 'none' }
            ]
          }
        },
        files: []
      }
    },
    components: {
    },
    methods: {
      ...mapActions('reports/', ['GET_REPORTS', 'GENERATE_REPORT']),
      generateReport() {
        this.$refs['reportParametersForm'].validate((valid) => {
          if (valid) {
            this.generatingReport = true
            let payload = {
              startDate: this.reportParameters.dateRange[0],
              endDate: this.reportParameters.dateRange[1],
              body: this.reports.find(x => x.reportPath === this.reportParameters.reportPath)
            }

            this.GENERATE_REPORT(payload).then(response => {
              this.files = []
              let fileName = this.getFileNameFromResponse(response)
              this.createDownloadableLink(response.data, fileName)
              this.generatingReport = false
            }, error => {
              this.$message.error('Error generating report')
              console.log(error)
              this.generateReport = false
            })
          }
        })
      },
      createDownloadableLink(file, fileName) {
        let blob = new Blob([file], { type: 'application/octet-stream' })
        this.files.push({
          fileUrl: window.URL.createObjectURL(blob),
          blob: blob,
          fileName: fileName,
          file: file,
          error: false
        })
      },
      getFileNameFromResponse(response) {
        var contdisp = response.headers['content-disposition']
        var parts = contdisp.split('; ')

        for (var i = 0; i < parts.length; i++) {
          if (parts[i].indexOf('filename=') > -1) {
            let filename = parts[1].replace('filename=', '')
            filename = filename.replace(/"/g, '')
            return filename
          }
        }
      },
      isIE() {
        let ua = window.navigator.userAgent

        let msie = ua.indexOf('MSIE ')
        if (msie > 0) {
          // IE 10 or older
          return true
        }

        let trident = ua.indexOf('Trident/')
        if (trident > 0) {
          // IE 11
          return true
        }

        let edge = ua.indexOf('Edge/')
        if (edge > 0) {
          return true
        }

        return false
      },
      downloadIe(row) {
        navigator.msSaveBlob(row.blob, row.fileName)
      }
    },
    created: function () {
      this.loading = true
      this.GET_REPORTS().then(() => {
        this.loading = false
      }, error => {
        console.log(error)
        this.$message.error('Error geting reports list')
        this.loading = false
      })
    },
    computed: {
      ...mapState('user/', ['currentClient', 'currentClientId']),
      ...mapState('reports/', ['reports'])
    }
  }
</script>
